import type { Formats } from "react-big-calendar"

export default function getCalendarFormats(timeFormat: 12 | 24): Formats {
  const formatString = timeFormat === 12 ? "hh:mm a" : "HH:mm"

  return {
    dayFormat: (date, culture, localizer) => localizer?.format(date, "dddd d", culture) || "",
    timeGutterFormat: formatString,
    eventTimeRangeFormat: ({ start, end }, culture, localizer) =>
      `${localizer?.format(start, formatString, culture) || ""} - ${localizer?.format(end, formatString, culture) || ""}`,
    agendaTimeRangeFormat: ({ start, end }, culture, localizer) =>
      `${localizer?.format(start, formatString, culture) || ""} - ${localizer?.format(end, formatString, culture) || ""}`,
  }
}
